export const request = async (url: string, options?: RequestInit) => {
  const response = await fetch(url, {
    method: !options ? 'GET' : options.method,
    body: options?.body,
    headers: {
        "Content-Type": "application/json"
    }
  })
  return checkReponse(response);
};

export const checkReponse = async (res: Response): Promise<any> => {
  const contentType = res.headers.get("content-type");
  if (contentType && contentType.includes("application/pdf")) {
    return res.blob();
  }
  const text = await res.text();
  const data = text ? JSON.parse(text) : {};
  return res.ok ? data : Promise.reject(data);
};

